/**
 *
 * IMPORTANT:
 * This file is used both in vue2 and vue3
 * Dont use the vue syntax and the store concept in this file.
 * For any clarifications please contact Leela
 *
 */
export function toyotaTrimMileageDetails(trim) {
  let output = null;
  if (trim) {
    let displayText = '';
    let displayMileageValue = '';

    let mpgCity = trim.mpgCity ? trim.mpgCity.toString().replace('-', '') : '';
    let mpgHighway = trim.mpgHighway ? trim.mpgHighway.toString().replace('-', '') : '';
    let epampgEquivalentCity = trim.epampgEquivalentCity
      ? trim.epampgEquivalentCity.toString().replace('-', '')
      : '';
    let epampgEquivalentHwy = trim.epampgEquivalentHwy
      ? trim.epampgEquivalentHwy.toString().replace('-', '')
      : '';
    let epampgEquivalentCombined = trim.epampgEquivalentCombined
      ? trim.epampgEquivalentCombined.toString().replace('-', '')
      : '';
    let estimatedBatteryRange = trim.estimatedBatteryRange
      ? trim.estimatedBatteryRange.toString().replace('-', '')
      : '';

    if (mpgCity && mpgHighway && epampgEquivalentCombined) {
      // THIS VEHICLE IS HYBRID
      displayText = [
        { text: 'MPG', disclaimer: '[3]', separator: true },
        { text: 'MPGe', disclaimer: '[3]' },
      ];
      displayMileageValue = `${mpgCity} / ${mpgHighway} / ${epampgEquivalentCombined}`;
      output = {
        displayText,
        displayMileageValue,
      };
    } else if (epampgEquivalentCity && epampgEquivalentHwy && estimatedBatteryRange) {
      // THIS VEHICLE IS ELECTRIC
      displayText = [
        { text: 'Est. MPGe', disclaimer: '[3]', separator: true },
        { text: 'Est. Range', disclaimer: '*' },
      ];
      displayMileageValue = ` ${epampgEquivalentCity} / ${epampgEquivalentHwy} / ${estimatedBatteryRange} `;
      output = {
        displayText,
        displayMileageValue,
      };
    } else if (!epampgEquivalentCity && !epampgEquivalentHwy && estimatedBatteryRange) {
      // THIS VEHICLE IS ELECTRIC
      displayText = [{ text: 'Est. Range', disclaimer: '*' }];
      displayMileageValue = `${estimatedBatteryRange}`;
      output = {
        displayText,
        displayMileageValue,
      };
    } else if (mpgCity && mpgHighway) {
      //THIS VEHICLE IS FUEL
      displayText = [{ text: 'Est MPG', disclaimer: '[3]' }];
      displayMileageValue = `${mpgCity} / ${mpgHighway}`;

      output = {
        displayText,
        displayMileageValue,
      };
    } else {
      displayText = [{ text: 'Est MPG', disclaimer: '[3]' }];
      displayMileageValue = `${mpgCity || '-'} / ${mpgHighway || '-'}`;
      output = {
        displayText,
        displayMileageValue,
      };
    }

    return output;
  }
}

export function toyotaTdapLinks(a) {
  let link = '#';
  switch (a.link) {
    case 'New Inventory':
      link = '/inventory/new';
      break;
    case 'TCUV':
      link = '/why-buy-certified';
      break;
    case 'College Grad Rebates':
      link = '/college-grad-rebate';
      break;
    case 'None':
      break;
    case 'Service':
      link = '/specials/service-specials';
      break;
    case 'New Incentives':
      link = '/incentives';
      break;
    case 'ToyotaCare':
      link = '/toyotacare';
      break;
    case 'Hybrid':
      link =
        '/inventory/new/toyota?paymenttype=lease&fueltypes=hybrid&instock=true&intransit=true&inproduction=true';
      break;
  }
  return link;
}

export function isToyotaCertified(type) {
  return (
    window.themeName?.toLowerCase() === 'toyota' &&
    (type === 'gold certified' || type === 'silver certified')
  );
}

export function getCertifiedSingleValue(type, reverse = false) {
  let op = '';
  if (type.toLowerCase() === 'gold certified') {
    op = reverse ? 'silver' : 'gold';
  }
  if (type.toLowerCase() === 'silver certified') {
    op = reverse ? 'gold' : 'silver';
  }
  return op;
}

export function preSelectedCertifiedTypes(dropdowndata) {
  return dropdowndata?.filter((t) => {
    return (t.value === 'Silver Certified' || t.value === 'Gold Certified') && t.selected;
  });
}

export function getToyotaCertifiedTypesSingleSelection(type, isCheckBoxSelection, dropdowndata) {
  let certifiedType = '';
  let filterUrl = '';
  let selectedCertifiedTypes = preSelectedCertifiedTypes(dropdowndata);
  if (isCheckBoxSelection) {
    certifiedType = getCertifiedSingleValue(type, false);
    filterUrl = `${window.baseUrl}/inventory/cpo?certifiedtypes=${certifiedType}`;
  } else if (selectedCertifiedTypes?.length === 2) {
    certifiedType = getCertifiedSingleValue(type, true);
    filterUrl = `${window.baseUrl}/inventory/cpo?certifiedtypes=${certifiedType}`;
  } else {
    filterUrl = `${window.baseUrl}/inventory/`;
  }
  return { certifiedType, filterUrl };
}

export function getToyotaCertifiedTypesMultipleSelection(
  type,
  isCheckBoxSelection,
  dropdowndata,
  url,
  updatedKeyValue
) {
  let certifiedType = '';
  let filterUrl = '';
  let selectedCertifiedTypes = preSelectedCertifiedTypes(dropdowndata);

  if (isToyotaCertified(type.toLowerCase())) {
    if (isCheckBoxSelection) {
      certifiedType = getCertifiedSingleValue(type, false);
      if (selectedCertifiedTypes?.length) {
        selectedCertifiedTypes.forEach((element) => {
          certifiedType =
            certifiedType + ',' + getCertifiedSingleValue(element.value.toLowerCase(), false);
        });
      }
      if (
        window.srpFilterPosition !== 'topmultiselect' &&
        !updatedKeyValue &&
        url.toLowerCase().includes('cpo')
      ) {
        url = url.toLowerCase().replace('cpo', '');
      }
      filterUrl = updatedKeyValue
        ? `${window.baseUrl}/inventory/${updatedKeyValue}?certifiedtypes=${certifiedType}`
        : `${url}?certifiedtypes=${certifiedType}`;
    } else if (selectedCertifiedTypes?.length === 2) {
      certifiedType = getCertifiedSingleValue(type, true);
      filterUrl = `${url}?certifiedtypes=${certifiedType}`;
    } else if (selectedCertifiedTypes?.length === 1) {
      certifiedType = '';
      filterUrl = `${url}?certifiedtypes=${certifiedType}`.replace(',cpo', '').replace('cpo,', '');
    } else {
      //No action needed for other cases
    }
  } else {
    if (selectedCertifiedTypes?.length) {
      selectedCertifiedTypes.forEach((element) => {
        certifiedType =
          certifiedType + ',' + getCertifiedSingleValue(element.value.toLowerCase(), false);
      });
    }
    if (certifiedType) {
      filterUrl = `${url}?certifiedtypes=${certifiedType}`;
    } else {
      filterUrl = `${url}`;
    }
  }

  filterUrl = filterUrl
    .toLowerCase()
    .replace('gold certified', 'cpo')
    .replace('silver certified', 'cpo')
    .replace('cpo,cpo', 'cpo')
    .replace(',,', ',');
  return { certifiedType, filterUrl };
}

export function getToyotaUrl(model) {
  const toyotaModels = [
    'tacoma 4wd',
    'tacoma-4wd',
    'tacoma-2wd',
    'tacoma 2wd',
    'tundra-4wd',
    'tundra 4wd',
    'tundra 2wd',
    'tundra-2wd',
  ];
  const normalizedModel = model ? model.toLowerCase() : '';

  if (!toyotaModels.includes(normalizedModel)) {
    return model; // Return original model if not in the list
  }

  // Split by both space and hyphen
  const [modelName, drivetrain] = normalizedModel.split(/\s*-\s*|\s+/);

  const drivetrainMap = {
    '4wd': '4wd,four wheel drive',
    '2wd': 'rwd,rear wheel drive',
  };

  const drivetrainFull = drivetrainMap[drivetrain] || '';

  return `${modelName}${drivetrainFull ? `?drivetrains=${drivetrainFull}` : ''}`;
}
